import React from 'react';
import { ExternalLink, Music, Sparkles } from 'lucide-react';
import { Link } from 'react-router';
import ScreenLayout from './ScreenLayout';

const getPlaylistUrl = () => {
    const configured = process.env.REACT_APP_YOUTUBE_PLAYLIST_URL?.trim();
    if (!configured) return '';

    try {
        const url = new URL(configured);
        return url.protocol === 'https:' ? url.toString() : '';
    } catch {
        return '';
    }
};

const WorshipVideos = () => {
    const playlistUrl = getPlaylistUrl();

    return (
        <ScreenLayout title="Worship Videos" icon={Music} tone="violet" eyebrow="Listen and worship">
            <section className="worship-hero">
                <p className="shared-kicker"><Sparkles size={14} /> Sing along</p>
                <h1>Worship through song.</h1>
                <p>Let a few minutes of praise turn your heart toward God.</p>
            </section>

            <section className="worship-empty" aria-live="polite">
                <Music size={28} />
                {playlistUrl ? (
                    <>
                        <h2>Your worship playlist is ready</h2>
                        <p>Open the connected YouTube playlist to choose a song and listen.</p>
                        <a href={playlistUrl} target="_blank" rel="noreferrer">
                            Open worship playlist <ExternalLink size={16} />
                        </a>
                    </>
                ) : (
                    <>
                        <h2>Worship videos aren’t available yet</h2>
                        <p>The in-app worship library is empty. Scripture and today’s guided reflection are still ready for you.</p>
                        <Link to="/devotionals">Open today’s devotional</Link>
                    </>
                )}
            </section>
        </ScreenLayout>
    );
};

export default WorshipVideos;
